import { useAppwideDrawerContext } from '../../../providers';
import { Box, HStack } from '../../Core';
import { Divider } from '../../Divider';
import { FormControlSizes, Toggle } from '../../Form';
import { Text } from '../../Text';
import type { EntityAdminRecord } from '../types';
import type { InputsAndDropdownsDrawerOptions } from './InputsAndDropdownsDrawer/types';
import { hasAnyGuideText } from './InputsAndDropdownsDrawer/utils';

export function EntityAdminGuideToggle({ fullWidth = false }: { fullWidth?: boolean }) {
  const { isGuideVisible, toggleGuide } = useAppwideDrawerContext();
  return (
    <HStack
      data-testid="entity-admin-show-guide-toggle"
      data-checked={isGuideVisible ? 'true' : 'false'}
      gap="spacing8"
      justifyContent={fullWidth ? 'space-between' : undefined}
      alignItems="center"
      cursor="pointer"
      onClick={toggleGuide}
    >
      <Text color="colors.gray.100" fontSize="fontSizeSm" whiteSpace="nowrap">
        Show Guide
      </Text>
      <Box
        onClick={event => {
          event.stopPropagation();
        }}
        display="flex"
      >
        <Toggle checked={isGuideVisible} onChange={toggleGuide} size={FormControlSizes.Small} />
      </Box>
    </HStack>
  );
}

export function EntityAdminGuideToggleWithDivider() {
  return (
    <HStack gap="spacing16" alignItems="center">
      <EntityAdminGuideToggle />
      <Divider orientation="vertical" />
    </HStack>
  );
}

export function getEntityAdminGuideHeaderContent<TDrawerRecord extends EntityAdminRecord>(
  drawerOptions: InputsAndDropdownsDrawerOptions<TDrawerRecord> | undefined,
  forceShowGuideToggle = false
): (() => JSX.Element) | undefined {
  if (!forceShowGuideToggle && (drawerOptions == null || !hasAnyGuideText(drawerOptions))) {
    return undefined;
  }

  return () => (
    <HStack gap="spacing16" alignItems="center">
      <EntityAdminGuideToggleWithDivider />
    </HStack>
  );
}
